export default __webpack_public_path__ + "static/media/GelBoxFullBuffer.8fb04e67.svg";